import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactDOMServer from 'react-dom/server';

class SiteHealth extends Component {
  componentDidMount() {
    $('.popovers').popover();
  }

  createList() {
    if (!this.props.popoverContent || this.props.popoverContent.length === 0) {
      return <ul className="sites_list"><li key={Math.random()}>No Data</li></ul>;
    }
    return (
      <ul className="sites_list">
        {this.props.popoverContent.map((message, index) => {
          return <li key={index}>{message}</li>;
        })}
      </ul>
    );
  }

  render() {
    return (
      <span
        className={`label label-sm label-hardware popovers`}
        data-container="body"
        data-trigger="hover"
        data-placement="bottom"
        data-html="true"
        data-content={ReactDOMServer.renderToStaticMarkup(this.createList())}
      >
        {this.props.value}
      </span>
    );
  }
}

SiteHealth.propTypes = {
  value: PropTypes.string,
  popoverTitle: PropTypes.string,
  popoverContent: PropTypes.array,
};
SiteHealth.defaultProps = {
  value: 'Unknown',
};

export default SiteHealth;
